import { render, staticRenderFns } from "./LoginChange.vue?vue&type=template&id=429fbf77&"
import script from "./LoginChange.vue?vue&type=script&lang=js&"
export * from "./LoginChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports